export class Tuple<T, S> {
  _1: T;
  _2: S;

  public static of<W, E>(_1: W, _2: E): Tuple<W, E> {
    const tuple: Tuple<W, E> = new Tuple<W, E>();
    tuple._1 = _1;
    tuple._2 = _2;

    return tuple;
  }
}
